import React from 'react';

interface IProps {
  tags: string[];
  title?: string;
}

const cornerStoneTags = [
  'dishwasher',
  'dryer',
  'cooking-appliance',
  'washer',
  'fridge',
];

const DEBUG = false;

export const BlogBreadCrumbs = (props: IProps) => {
  if (DEBUG) {
    console.log('BlogBreadCrumbs props', props);
  }
  let cornerStone: string = 'general';

  const { tags, title } = props;
  if (tags) {
    tags.forEach(tag => {
      cornerStoneTags.forEach(csTag => {
        if (csTag.toLowerCase() === tag.toLowerCase()) {
          cornerStone = csTag;
        }
      });
    });
  }

  const cornerStoneDesc = () => {
    switch (cornerStone) {
      case 'dishwasher':
        return { url: 'dishwashers', desc: 'Dishwashers' };
      case 'dryer':
        return { url: 'dryers', desc: 'Dryers' };
      case 'cooking-appliance':
        return { url: 'cooking-appliances', desc: 'Cooking Appliances' };
      case 'washer':
        return { url: 'washers', desc: 'Washers' };
      case 'fridge':
        return { url: 'refrigerators', desc: 'Fridges' };
      case 'general':
      default:
        return { url: 'blog', desc: 'General' };
    }
  };
  return (
    <nav className="breadcrumb" aria-label="breadcrumbs">
      <ul style={{ marginLeft: '0px' }}>
        <li style={{ paddingTop: '4px' }}>
          <a href="/">Home</a>
        </li>
        <li>
          <a href={'/' + cornerStoneDesc().url}>{cornerStoneDesc().desc}</a>
        </li>
        <li className="is-active">
          <a href="#" aria-current="page">
            {title}
          </a>
        </li>
      </ul>
    </nav>
  );
};
